import { LegalLayout, H2, P, A, UL, Strong } from "@/components/LegalLayout";

// Edit these two placeholders freely:
const LAST_UPDATED = "June 16, 2026"; // [DATE]
const CONTACT_EMAIL = "compliance@aipathshaalaa.com"; // [EMAIL]

export default function Compliance() {
  return (
    <LegalLayout
      testid="compliance-page"
      eyebrow="YouTube API Services"
      title="YouTube API Services Compliance Policy — AI Pathshaalaa"
      updated={LAST_UPDATED}
    >
      <P>
        AI Pathshaalaa ("we", "us", "the Platform") uses YouTube API Services to discover, embed, and
        sequence publicly available educational videos. This policy explains how we comply with
        YouTube's terms and what users can expect.
      </P>

      <H2>1. We Use Official YouTube API Services Only</H2>
      <P>
        We access YouTube content exclusively through the official YouTube Data API and the YouTube
        IFrame Player API. We do not scrape, crawl, or extract data through any unofficial method.
      </P>

      <H2>2. We Never Host, Download, or Store Videos</H2>
      <P>
        All videos play through YouTube's official embedded player. We do not download, copy, cache,
        back up, or rehost any YouTube video or audio, and we do not enable offline playback. Videos
        always stream live from YouTube, and all views, watch time, ads, and revenue belong entirely
        to the original creators and YouTube.
      </P>

      <H2>3. What We Charge For — Curation, Not Videos</H2>
      <P>
        We do not sell, and never will sell, access to YouTube videos. YouTube videos on this
        platform remain freely available on YouTube. Our paid product is our independent value layer:
        AI-curated and sequenced learning roadmaps, course structure, AI-generated summaries, quizzes,
        practice tasks, progress tracking, and personalization. Any fee is solely for this curation
        and learning experience that we create — not for the underlying videos.
      </P>

      <H2>4. Creators Keep 100% of Their Views and Credit</H2>
      <P>
        Every embedded video is clearly attributed to its original creator and channel, links back to
        the original video on YouTube, and plays in the official player so creators receive full view
        counts, watch time, and any associated YouTube ad revenue.
      </P>

      <H2>5. We Respect the YouTube Player and Branding</H2>
      <P>
        We display the official YouTube embedded player without modification. We do not overlay our
        own advertisements on the player, alter YouTube branding, hide YouTube controls, or interfere
        with YouTube's user interface.
      </P>

      <H2>6. Data Handling</H2>
      <P>
        We refresh or delete YouTube API data in line with YouTube's data storage requirements and do
        not store such data beyond the permitted period. We check the "Made for Kids" status of
        embedded content and disable personalized data collection on such content as required.
      </P>

      <H2>7. Agreement to YouTube Terms</H2>
      <P>
        By using AI Pathshaalaa, you also agree to be bound by the{" "}
        <A href="https://www.youtube.com/t/terms">YouTube Terms of Service</A>. Our use of information
        from YouTube API Services is also subject to the{" "}
        <A href="https://policies.google.com/privacy">Google Privacy Policy</A>.
      </P>

      <H2>8. Removal and Freshness</H2>
      <P>
        If a creator's video is deleted, made private, or removed, it will no longer appear on our
        Platform. Creators who wish to have their content removed from our curated paths may contact
        us at <Strong>{CONTACT_EMAIL}</Strong> and we will promptly comply.
      </P>

      <H2>9. Contact</H2>
      <P>
        For any compliance, content, or takedown queries: <Strong>{CONTACT_EMAIL}</Strong>
      </P>
    </LegalLayout>
  );
}
